import type { JSONConfig } from '@/engine/app/interfaces.ts';
import { OrientationType } from '@/engine/app/modules/images/interfaces.ts';

export const front: JSONConfig.Orientation = {
  descriptor: OrientationType.FRONT,
  topVector: [0, 0, 1],
  directionVector: [0, -1, 0]
};
